import React, { 
    useEffect, 
    useRef, 
    useState 
} from 'react';
import './store-buttons.styles.scss';
import { 
    faCubesStacked, 
    faDice, 
    faGift, 
    faGlobeAmericas, 
    faPiggyBank, 
    faShoppingCart, 
    faTicket 
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';


const StoreButtons = ({ 
    gameData,
    allItems, 
    setItemType, 
    itemType,
    isManager,
    skipInitialType
}) => {
    
    const screenSize = useSelector(state => state.contentData.screenSize);
    const shoppingCart = useSelector(state => state.userData.shoppingCart);
    const [ counts, setCounts ] = useState({})
    const [ initialTypeIsSet, setInitialTypeIsSet ] = useState(false);
    const [ itemTypeArr ] = useState([
        'inventory',
        'realworld',
        'collectible',
        'lottery',
        'prizepack',
        'contribution'
    ]);
    const textRef = useRef(null);
    const location = useLocation();

    // Set initial item type based on available items
    useEffect(() => {
        // skipped when the type comes from a #type anchor in the url
        if (!allItems || initialTypeIsSet || skipInitialType) return;
        
        for (let type of itemTypeArr) {
            let availItems = Object.values(allItems)
            .filter(i =>
                i.type === 'item' &&
                i.opt_visible
            )
            const typeCount = availItems.filter(i => i.opt_itemType === type).length
            if (typeCount > 0) {
                setItemType(type);
                setInitialTypeIsSet(true);
                return;
            }
        }
    }, [allItems, initialTypeIsSet, skipInitialType])

    // Set counts for each item type
    useEffect(() => {
        if (!allItems) return;
        let countObj = {};
        itemTypeArr.forEach(type => {
            countObj[type] = 0;
        })
        itemTypeArr.forEach(type => {
            countObj[type] = Object.values(allItems)
            .filter(i => i.opt_itemType === type).length;
        })
        setCounts({...countObj});
        console.log(countObj);
    }, [allItems, itemTypeArr])

    return (
        <div className={`store-buttons ${screenSize} ${isManager ? 'manager' : ''}`}>
            <button 
                className={
                    `g-button med-btn ${
                        itemType === "inventory" 
                        ? "primary"
                        : ""
                    }`
                }
                ref={textRef}
                onClick={() => setItemType("inventory")}
                title='Game Items' >
                <FontAwesomeIcon icon={faDice} size="lg" />
                {
                    (
                        screenSize !== 'mobile' && 
                        screenSize !== 'largeTablet'
                    )
                    ?
                    'Inventory'
                    :
                    ''
                }
            </button>
            <button 
                className={
                    `g-button med-btn ${
                        itemType === "realworld" 
                        ? "primary" 
                        : ""
                    }`
                }
                onClick={() => setItemType("realworld")}
                ref={textRef}
                title='Real Items'
            >
                <FontAwesomeIcon icon={faGlobeAmericas} size="lg" />
                {
                    (
                        screenSize !== 'mobile' && 
                        screenSize !== 'largeTablet'
                    )
                    ?
                    'Real Items'
                    :
                    ''
                }
            </button>
            <button 
                className={
                    `g-button med-btn ${
                        itemType === "collectible"
                        ? "primary"
                        : ""
                    } ${
                        (counts.collectible === 0) ? 'disabled' : ''
                    }`
                }
                onClick={() => setItemType("collectible")}
                ref={textRef}
                title='Collectibles'
            >
                <FontAwesomeIcon icon={faCubesStacked} size="lg" />
                {
                    (
                        screenSize !== 'mobile' && 
                        screenSize !== 'largeTablet'
                    )
                    ?
                    'Collectibles'
                    :
                    ''
                }
            </button>
            <button 
                className={
                    `g-button med-btn ${
                        itemType === "lottery" 
                        ? "primary"
                        : ""
                    } ${
                        (counts.lottery === 0) ? 'disabled' : ''
                    }`
                }
                onClick={() => setItemType("lottery")}
                ref={textRef}
                title='Lottery Tickets'
            >
                <FontAwesomeIcon icon={faTicket} size="lg" />
                {
                    (
                        screenSize !== 'mobile' && 
                        screenSize !== 'largeTablet'
                    )
                    ?
                    'Lottery Tickets'
                    :
                    ''
                }
            </button>
            <button 
                className={
                    `g-button med-btn ${
                        itemType === "prizepack" 
                        ? 'primary' 
                        : ''
                    } ${
                        (counts.prizepack === 0) ? 'disabled' : ''
                    }`
                }
                onClick={() => setItemType("prizepack")}
                ref={textRef}
                title='Prize Packs'
            >
                <FontAwesomeIcon icon={faGift} size="lg" />
                {
                    (
                        screenSize !== 'mobile' && 
                        screenSize !== 'largeTablet'
                    )
                    ?
                    'Prize Packs'
                    :
                    ''
                }
            </button>
            <button 
                className={
                    `g-button med-btn ${
                        itemType === "contribution" 
                        ? "primary"
                        : ""
                    } ${
                        (counts.contribution === 0) ? 'disabled' : ''
                    }`
                }
                onClick={() => setItemType("contribution")}
                ref={textRef}
                title='Contributions'
            >
                <FontAwesomeIcon icon={faPiggyBank} size="lg" />
                {
                    (
                        screenSize !== 'mobile' && 
                        screenSize !== 'largeTablet'
                    )
                    ?
                    'Contributions'
                    :
                    ''
                }
            </button>
            {
                (
                    !isManager &&
                    (
                        screenSize === 'mobile' || 
                        screenSize === 'largeTablet'
                    )
                )
                &&
                
                    <Link to={`/play/${gameData.path}/marketplace/shoppingcart`}>
                        <div className='notification-with-badge'>
                            <button className={`g-button med-btn ${
                                shoppingCart && 
                                Object.values(shoppingCart).length > 0 
                                ? 'primary' 
                                : ''
                            }`}>
                                <FontAwesomeIcon icon={faShoppingCart} size="lg" />
                                {
                                    (
                                    screenSize !== 'mobile' && 
                                    screenSize !== 'largeTablet'
                                    )
                                    ?
                                    'Shopping Cart'
                                    :
                                    ''
                                }
                            </button>
                            {
                                shoppingCart &&
                                Object.values(shoppingCart).length > 0 &&
                                <div className='badge'>{Object.values(shoppingCart).length}</div>
                            }
                        </div>
                    </Link>
            }
            {/* {
                (gameData.access.includes('tradePortal')) &&
                <button 
                    className={
                        `g-button med-btn ${
                            itemType === "tradeportal" 
                            ? 'primary' 
                            : ''
                        }`
                    }
                    onClick={() => setItemType("tradeportal")}
                    ref={textRef}
                    title='Trade Portal'
                >
                    <FontAwesomeIcon icon={faExchange} size={showText ? 'lg' : 'xl'} />
                    {
                        screenSize !== 'mobile'
                        ?
                        'Trade Portal'
                        :
                        ''
                    }
                </button>
            } */}
        </div>
    )
}

export default StoreButtons